// extracted by mini-css-extract-plugin
export var container = "index-module--container--g0OsZ";
export var gatsbyImage = "index-module--gatsbyImage--kU8WE";
export var wrapper = "index-module--wrapper--00TTJ";